import {
    ShoppingCartData,
    CityState,
    Term,
    ServiceAddressResponse, CartDataRequest, SupportAvailability, AvailabilityType,
} from './ProductsAndServicesModels';
import { CrossSale, CrossSaleRequest } from './CrossSaleModels'
import {HTTP} from '@/services/HttpServices';

export function cartData(orderDetails: CartDataRequest, cartNumber: string): Promise<ShoppingCartData> {
    return HTTP.post(`/public/customer-cart/${cartNumber || ''}`, orderDetails);
}

export function getSearchAddressResults(searchAddress: string, searchZip: string, email?: string): Promise<ServiceAddressResponse> {
    return HTTP.get(`/public/service-addresses?searchAddress=${encodeURIComponent(searchAddress)}&searchZip=${searchZip}&email=${email}`);
}

export function getSearchEmailAddressResults(email?: string): Promise<ServiceAddressResponse> {
    return HTTP.get(`/public/service-addresses?email=${email}`);
}
export function getStates(): Promise<CityState[]> {
    return HTTP.get('/public/states');
}

export function loadCrossSales({pageId, audience, cartId}: CrossSaleRequest): Promise<CrossSale[]> {
  return HTTP.get(`/public/cross-sales?pageId=${pageId}&audience=${audience}&cartId=${cartId}`);
}
export function getSupportAvailability(): Promise<SupportAvailability> {
    return HTTP.get(`/public/availability-schedules?type=${AvailabilityType.SUPPORT}`);
}

export function isNowAvailable(): Promise<{ nowAvailable: boolean }> {
    return HTTP.get(`/public/availability-schedules/current-datetime`);
}

export async function getTerms(isResidential: boolean): Promise<Term[]> {
    const terms = await HTTP.get(`/public/terms`) as Term[];
    return terms.filter((t) => {
        if (isResidential) {
            return t.audience.toLowerCase() === 'residential' || t.audience.toLowerCase() === 'both';
        } else {
            return t.audience.toLowerCase() === 'business' || t.audience.toLowerCase() === 'both';
        }
    });
}
